module.exports = __webpack_public_path__ + "img/balance.d9ed6a10.svg";